import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import ThingProvider from '../ThingProvider'
import SingleThing from '../SingleThing'
import ThingContentStyles from '../ThingContentStyles'
import EditThingForm from '../../../pages/admin/AssetDetails/ContentTab/Things/EditDialog/form'
function ThingDialogForm ({ config, isEdit, onComplete, onCancel }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ThingProvider levelTypeId={config.levelTypeId} levelId={config.levelId} showLoading>
          {isEdit ? (
            <EditThingForm
              asset={{ levelTypeId: config.levelTypeId, assetId: config.levelId }} thing={{ content: config.content, ordinal: config.ordinal }} thingConfiguration={{
                code: config.code,
                description: 'Custom Content'
              }} onComplete={onComplete} onCancel={onCancel}
            />
          ) : (
            <ThingContentStyles jss={{ padding: 0 }}>
              <SingleThing hideIfEmpty={false} showHeader={false} variant='borderless' code={config.code} />
            </ThingContentStyles>
          )}
        </ThingProvider>
      </Grid>
    </Grid>
  )
}

ThingDialogForm.propTypes = {
  config: PropTypes.shape({
    asset: PropTypes.shape({
      levelId: PropTypes.number.isRequired,
      levelTypeId: PropTypes.number.isRequired
    }),
    code: PropTypes.string.isRequired,
    content: PropTypes.string,
    ordinal: PropTypes.number,
    levelTypeId: PropTypes.number.isRequired,
    levelId: PropTypes.number.isRequired
  }),
  isEdit: PropTypes.bool,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default ThingDialogForm
